<template>
    <div class="ui centered grid">
         <div class="five wide column">
             <TheGraph graphname="inventory" v-bind:query="query"></TheGraph>
        </div>
         <div class="five wide column">
         
        </div>
         <div class="five wide column"> </div>
    </div>
</template>

<script>
    import TheGraph from '../components/TheGraph.vue';
    
    export default {
        props: ['query'],
        data() {
            return {

            }
        },

        methods: {

        },

        mounted() {},
        components: {
            TheGraph
        },

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/TheDashboardTab.vue